import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { Constants } from 'app/shared/shared-constants';
import { format } from 'app/shared/utils/string.util';
import { maxConcurrentConnectionsMetadata, preCopyScriptMetadata, queryTimeoutMetadata } from '../consts/metadata-consts';

export const odbcTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.odbc.datasetType,
    displayName: stringResources.Odbc_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.odbc.linkedServiceType],
    isSource: true,
    isSink: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-PlaceHolderDatabase'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    category: ['GenericProtocol'],
    copySourceControls: [queryTimeoutMetadata],
    copySinkControls: [
        preCopyScriptMetadata(),
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'writeBatchTimeout',
                label: stringResources.ModelName_WriteBatchTimeout,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_WriteBatchTimeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                defaultValue: 0,
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata
    ],
    copyJob: {
        multipleQuery: true
    }
};
